module.exports = __webpack_public_path__ + "static/media/social-media-icon-active.d962ae33.svg";